// We moved this into its own file so that we can mock it in Jest.
// Jest doesn't support ESM, and import.meta is an ESM feature.
// See: https://stackoverflow.com/questions/64961387/how-to-use-import-meta-when-testing-with-jest

export const getArrangeWorker = (): Worker =>
  new Worker(
    new URL('../../../utils/arrange/nodeArrangeWorker.ts', import.meta.url),
  );
